<template>
  <div>
    <Tabs value="certificateTag" type="card">
      <TabPane label="凭证" name="certificateTag">
        <Modal
          v-model="unlockModal"
          footer-hide
          title="查看密码/密钥"
          @on-cancel="unlockModalCancel">
          <Input
            search
            enter-button="解密"
            @on-search="unlockSubmit"
            type="password"
            v-model="unlock.currentUserPassword"
            placeholder="请输入当前用户密码"
            :style="{margin: '0 auto', marginBottom: '10px'}">
            <span slot="prepend">用户密码</span>
          </Input>
          <Input
            v-model="displayPassword"
            disabled
            v-show="IsPasswordShow"
            placeholder="解密后显示密码"
            :style="{margin: '0 auto', marginBottom: '10px'}">
            <span slot="prepend">解密密码</span>
          </Input>
          <Input
            v-model="displayPassword"
            disabled
            v-show="!IsPasswordShow"
            placeholder="解密后显示密钥"
            type="textarea"
            :style="{marginBottom: '10px'}">
          </Input>
        </Modal>
        <Drawer
          :title="certificateModalTitle"
          v-model="certificateModal"
          width="682"
          :mask-closable="true"
          @on-close="certificateModalCancel">
          <div>
            <Form ref="certificateForm" :model="certificateForm" :label-width="90" :rules="certificateRule">
              <FormItem label="名称" prop="name">
                <Input v-model="certificateForm.name" />
              </FormItem>
              <FormItem label="协议" prop="protocol">
                <Select v-model="certificateForm.protocol" @on-change="handleCertificate">
                  <Option v-for="item in allProtocolData" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
              </FormItem>
              <FormItem label="用户名" prop="username">
                <Input v-model="certificateForm.username" />
              </FormItem>
              <FormItem label="端口" prop="port">
                <Input  v-model="certificateForm.port" number />
              </FormItem>
              <FormItem label="密码" prop="key"  v-show="pwdVisible">
                <Input type="password" v-model="certificateForm.key" />
              </FormItem>
           <form-item label="密钥" prop="key" v-show="keyVisible">
            <i-input  v-model="certificateForm.key" placeholder="请粘贴私钥" type="textarea" :autosize="{minRows: 15,maxRows: 25}" ></i-input>
          </form-item>
             <FormItem label="管理员凭证" prop="key">
            <i-switch v-model="certificateForm.is_admin" size="large">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
             </FormItem>
            <FormItem label="关联用户" prop="users">
            <transfer
              :data="no_select_users"
              :target-keys="certificateForm.users"
              :list-style="listStyle"
              @on-change="userChange"
              filterable></transfer>
          </FormItem>
          <form-item label="关联用户组" prop="groups">
            <transfer
              :data="no_select_groups"
              :target-keys="certificateForm.groups"
              :list-style="listStyle"
              @on-change="groupChange"
              filterable></transfer>
          </form-item>
           <FormItem label="关联主机" prop="hosts">
            <transfer
              :data="no_select_hosts"
              :target-keys="certificateForm.hosts"
              :list-style="listStyle"
              @on-change="hostChange"
              filterable></transfer>
          </FormItem>
          <FormItem label="关联主机组" prop="asset_groups">
            <transfer
              :data="no_select_asset_groups"
              :target-keys="certificateForm.asset_groups"
              :list-style="listStyle"
              @on-change="hostGroupChange"
              filterable></transfer>
          </FormItem>
              <FormItem label="备注" prop="remark">
                <Input v-model="certificateForm.remark" />
              </FormItem>
              <FormItem>
                <i-button type="primary" @click="certificateSubmit">提交</i-button>
                <i-button style="margin-left: 8px" @click="certificateModal = false">取消</i-button>
              </FormItem>
            </Form>
          </div>
        </Drawer>
        <Card>
          <Row>
            <Col span="24" :md="22">
              <Form ref="certificateSearchForm" inline :model="certificateSearchForm" :label-width="50">
                <FormItem label="名称">
                  <Input v-model="certificateSearchForm.name" style="min-width: 150px;" />
                </FormItem>
                <FormItem label="用户名">
                  <Input v-model="certificateSearchForm.username" style="min-width: 150px;" />
                </FormItem>
                <FormItem label="协议">
                  <Select v-model="certificateSearchForm.protocol" style="min-width:150px">
                    <Option v-for="item in allProtocolData" :value="item.id" :key="item.id">{{ item.name }}</Option>
                  </Select>
                </FormItem>
                <FormItem label="端口">
                  <Input v-model="certificateSearchForm.port" style="min-width: 150px;" />
                </FormItem>
                <FormItem :label-width="0" class="mob-align-right">
                  <Button type="primary" @click="getCertificateData()">搜索</Button>
                  <Button @click="certificateSearchReset" style="margin-left: 10px">重置</Button>
                </FormItem>
              </Form>
            </Col>
            <Col span="24" :md="2">
              <Button style="float: right; " v-show="isCertificateAdd"  @click="certificateModal = true; certificateModalTitle = '添加凭证'" type="primary" :style="{marginBottom: '10px'}" icon="md-add">添加凭证</Button>
            </Col>
          </Row>
          <Table
            border
            highlight-row
            :loading="certificateTableLoading"
            ref="table"
            :data="certificate.data"
            :columns="certificate.columns">
          </Table>
          <div style="margin: 10px 0; overflow: hidden;">
            <div style="float: right;">
              <page
                :total="certificate.count"
                :current="certificate.page"
                :page-size="certificate.size"
                @on-change="getCertificateData"></page>
            </div>
          </div>
        </Card>
      </TabPane>
      <TabPane label="协议" name="protocolTag">
        <Drawer
          :title="protocolModalTitle"
          v-model="protocolModal"
          width="500"
          :mask-closable="true"
          @on-close="protocolModalCancel">
          <div>
            <Form ref="protocolForm" :model="protocolForm" :label-width="50" :rules="protocolRule">
              <FormItem label="名称" prop="name">
                <Input v-model="protocolForm.name" />
              </FormItem>
              <FormItem label="协议" prop="type">
                <Select v-model="protocolForm.type">
                  <Option v-for="item in protocolTypeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
              <FormItem>
                <i-button type="primary" @click="protocolSubmit">提交</i-button>
                <i-button style="margin-left: 8px" @click="protocolModal = false">取消</i-button>
              </FormItem>
            </Form>
          </div>
        </Drawer>
        <Card>
          <Row>
            <Col>
              <Button style="float: right; " v-show="isProtocolAdd" @click="protocolModal = true; protocolModalTitle = '添加协议'" type="primary" :style="{marginBottom: '10px'}" icon="md-add">添加协议</Button>
            </Col>
          </Row>
          <Table
            border
            :loading="protocolTableLoading"
            ref="table"
            :data="protocol.data"
            :columns="protocol.columns">
          </Table>
          <div style="margin: 10px 0; overflow: hidden;">
            <div style="float: right;">
              <page
                :total="protocol.count"
                :current="protocol.page"
                :page-size="protocol.size"
                @on-change="getProtocolData"></page>
            </div>
          </div>
        </Card>
      </TabPane>
    </Tabs>
    <Drawer :closable="true" width="640" v-model="LogsModel">
      <Tabs type="card">
        <TabPane label="修改日志">
          <Logs :logs="RevisionLogs" />
        </TabPane>
        <TabPane label="解锁日志">
          <unlockLogs :logs="UnlockLogs" />
        </TabPane>
      </Tabs>
    </Drawer>
  </div>
</template>

<script>
import { getOpsCenterCertificate, changeOpsCenterCertificate, getOpsCenterAllProtocol,
  deleteOpsCenterCertificate, getOpsCenterProtocol, changeOpsCenterProtocol, deleteOpsCenterProtocol,
  getContentTypeId, getRevisionLogs, UnlockCertificateKey, getUnlockLogs, getOpsCenterAllServer, getOpsCenterServerGroup } from '@/api/opscenter'
import { GetALLUsers, getAllGroup } from '@/api/user'
import Logs from './Logs'
import unlockLogs from './unlock-logs'

export default {
  name: 'certificate-manage',
  components: {
    'Logs': Logs,
    'unlockLogs': unlockLogs
  },
  data () {
    return {
      no_select_groups: [],
      no_select_asset_groups: [],
      isCertificateAdd: false,
      isCertificateEdit: false,
      isCertificateView: false,
      isCertificateDelete: false,
      isCertificateDecode: false,
      isProtocolAdd: false,
      isProtocolEdit: false,
      isProtocolView: false,
      isProtocolDelete: false,
      certificateModalTitle: '添加凭证',
      certificateModal: false,
      allProtocolData: [],
      no_select_users: [],
      no_select_hosts: [],
      pwdVisible: true,
      keyVisible: false,
      certificateForm: {
        id: 0,
        name: '',
        protocol: '',
        username: '',
        port: '',
        key: '',
        is_admin: true,
        users: [],
        hosts: [],
        remark: '',
        groups: [],
        asset_groups: []
      },
      listStyle: {
        width: '240px',
        height: '300px'
      },
      certificateRule: {
        name: [
          { required: true, message: '凭证名称不能为空', trigger: 'blur' }
        ],
        username: [
          { required: true, message: '凭证用户名不能为空', trigger: 'blur' }
        ],
        port: [
          { required: true, type: 'number', message: '端口不能为空、且必须为数字', trigger: 'blur' }
        ],
        key: [
          { required: true, message: 'Key不能为空', trigger: 'blur' }
        ],
        protocol: [{ type: 'number', required: true, message: '请选择凭证协议', trigger: 'change' }]
      },
      certificateSearchForm: {
        name: '',
        protocol: '',
        username: '',
        port: ''
      },
      certificateTableLoading: false,
      certificate: {
        data: [],
        columns: [
          {
            title: '凭证ID',
            key: 'id',
            align: 'center',
            minWidth: 75
          },
          {
            title: '凭证名称',
            key: 'name',
            align: 'center',
            minWidth: 120
          },
          {
            title: '用户名',
            key: 'username',
            align: 'center',
            minWidth: 120
          },
          {
            title: '协议',
            key: 'protocol',
            align: 'center',
            minWidth: 150,
            render: (h, params) => {
              if (params.row.protocol) {
                return h('div', params.row.protocol.name)
              } else {
                return ''
              }
            }
          },
          {
            title: '端口',
            key: 'port',
            align: 'center',
            minWidth: 80
          },
          {
            title: '操作',
            align: 'center',
            minWidth: 220,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.unlockModalCancel()
                      this.revisionLog(params.row.id, this.certificateContentTypeId)
                      this.unlockLog(params.row.id)
                      this.LogsModel = true
                    }
                  }
                }, '日志'),
                h('Button', {
                  props: {
                    type: 'success',
                    size: 'small'
                  },
                  style: {
                    display: this.isCertificateDecode ? 'inline-block' : 'none',
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      if (params.row.protocol) {
                        if (params.row.protocol.type === 0) {
                          this.IsPasswordShow = true
                        } else {
                          this.IsPasswordShow = false
                        }
                      } else {
                        this.IsPasswordShow = true
                      }
                      this.unlock.certificate_id = params.row.id
                      this.unlockModal = true
                    }
                  }
                }, '解密'),
                h('Button', {
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px',
                    display: this.isCertificateEdit ? 'inline-block' : 'none'
                  },
                  on: {
                    click: () => {
                      this.certificateModifyOpen(params.row)
                    }
                  }
                }, '编辑'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.certificateDelete(params.row)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    },
                    style: {
                      display: this.isCertificateDelete ? 'inline-block' : 'none'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 1,
        page: 1,
        size: 10
      },

      protocolModalTitle: '添加协议',
      protocolModal: false,
      protocolTypeList: [{ 'value': 0, 'label': '密码' }, { 'value': 1, 'label': '密钥' }],
      protocolForm: {
        id: 0,
        name: '',
        type: 0
      },
      protocolRule: {
        name: [
          { required: true, message: '协议名称不能为空', trigger: 'blur' }
        ]
      },
      protocolTableLoading: false,
      protocol: {
        data: [],
        columns: [
          {
            type: 'selection',
            minWidth: 45,
            align: 'center'
          },
          {
            title: '协议ID',
            key: 'id',
            align: 'center',
            minWidth: 80
          },
          {
            title: '协议名称',
            key: 'name',
            align: 'center',
            minWidth: 120
          },
          {
            title: '协议类型',
            key: 'type',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              if (params.row.type === 0) {
                return h('div', '密码')
              } else if (params.row.type === 1) {
                return h('div', '密钥')
              } else {
                return ''
              }
            }
          },
          {
            title: '操作',
            align: 'center',
            minWidth: 180,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'success',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.revisionLog(params.row.id, this.protocolContentTypeId)
                      this.LogsModel = true
                    }
                  }
                }, '日志'),
                h('Button', {
                  style: {
                    display: this.isProtocolEdit ? 'inline-block' : 'none',
                    marginRight: '5px'
                  },
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.protocolModifyOpen(params.row)
                    }
                  }
                }, '编辑'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.protocolDelete(params.row)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    },
                    style: {
                      display: this.isProtocolDelete ? 'inline-block' : 'none'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 1,
        page: 1,
        size: 10
      },

      certificateContentTypeId: '',
      protocolContentTypeId: '',
      LogsModel: false,
      RevisionLogs: [],

      UnlockLogs: [],
      unlockModal: false,
      unlock: {
        certificate_id: '',
        currentUserPassword: ''
      },
      displayPassword: '',
      IsPasswordShow: true
    }
  },
  mounted: function () {
    this.initOperatePerm()
    this.getCertificateData()
    this.getAllProtocol()
    this.getProtocolData()
    this.getNoSelectUser()
    this.getNoSelectHost()
    this.getNoSelectGroup()
    this.getNoSelectHostGroup()
    getContentTypeId({ 'model_name': 'Certificate' }).then(res => {
      let result = res.data
      this.certificateContentTypeId = result.content_type_id
    })
    getContentTypeId({ 'model_name': 'Protocol' }).then(res => {
      let result = res.data
      this.protocolContentTypeId = result.content_type_id
    })
  },
  methods: {
    getNoSelectGroup () {
      let that = this
      that.no_select_groups = []
      getAllGroup().then(res => {
        if (res.status === 200) {
          let result = res.data
          for (let i in result) {
            that.no_select_groups.push({
              key: result[i].id,
              label: result[i].name
            })
          }
        }
      })
    },
    getNoSelectHostGroup () {
      let that = this
      that.no_select_asset_groups = []
      getOpsCenterServerGroup().then(res => {
        if (res.status === 200) {
          let result = res.data
          for (let i in result) {
            that.no_select_asset_groups.push({
              key: result[i].id,
              label: result[i].name
            })
          }
        }
      })
    },
    groupChange (newTargetKeys) {
      this.certificateForm.groups = newTargetKeys
    },
    hostGroupChange (newTargetKeys) {
      this.certificateForm.asset_groups = newTargetKeys
    },
    // 初始化页面按钮权限（增删改查操作权限）
    initOperatePerm () {
      let permissions = this.$store.state.user.permissions
      if (permissions.indexOf('add_certificate') > -1) {
        this.isCertificateAdd = true
      } else {
        this.isCertificateAdd = false
      }
      if (permissions.indexOf('change_certificate') > -1) {
        this.isCertificateEdit = true
      } else {
        this.isCertificateEdit = false
      }
      if (permissions.indexOf('delete_certificate') > -1) {
        this.isCertificateDelete = true
      } else {
        this.isCertificateDelete = false
      }
      if (permissions.indexOf('view_certificate') > -1) {
        this.isCertificateView = true
      } else {
        this.isCertificateView = false
      }
      if (permissions.indexOf('can_certificate_decode') > -1) {
        this.isCertificateDecode = true
      } else {
        this.isCertificateDecode = false
      }
      if (permissions.indexOf('add_protocol') > -1) {
        this.isProtocolAdd = true
      } else {
        this.isProtocolAdd = false
      }
      if (permissions.indexOf('change_protocol') > -1) {
        this.isProtocolEdit = true
      } else {
        this.isProtocolEdit = false
      }
      if (permissions.indexOf('delete_protocol') > -1) {
        this.isProtocolDelete = true
      } else {
        this.isProtocolDelete = false
      }
      if (permissions.indexOf('view_protocol') > -1) {
        this.isProtocolView = true
      } else {
        this.isProtocolView = false
      }
    },
    // 切换凭证协议，默认给端口赋值
    handleCertificate (value) {
      let result = this.allProtocolData.filter(item => item.id === value)
      // 0--密码 1 - 密钥
      if (result[0].name.indexOf('ssh') > -1 && result[0].type === 0) {
        this.certificateForm.port = 22
        this.keyVisible = false
        this.pwdVisible = true
        this.certificateForm.key = ''
      } else if (result[0].name.indexOf('ssh') > -1 && result[0].type === 1) {
        this.certificateForm.port = 22
        this.keyVisible = true
        this.pwdVisible = false
        this.certificateForm.key = ''
      } else if (result[0].name.indexOf('rdp') > -1) {
        this.certificateForm.port = 3389
        this.keyVisible = false
        this.pwdVisible = true
        this.certificateForm.key = ''
      } else if (result[0].name.indexOf('vnc') > -1) {
        this.certificateForm.port = 5901
        this.keyVisible = false
        this.pwdVisible = true
        this.certificateForm.key = ''
      } else if (result[0].name.indexOf('telnet') > -1) {
        this.certificateForm.port = 23
        this.certificateForm.key = ''
        this.keyVisible = false
        this.pwdVisible = true
      }
    },
    // 凭证
    certificateModalCancel () {
      this.certificateFormReset()
    },
    certificateSubmit () {
      this.$refs['certificateForm'].validate((valid) => {
        if (valid) {
          changeOpsCenterCertificate(this.certificateForm, this.certificateForm.id).then(res => {
            this.$Notice.success({
              title: '操作成功'
            })
            this.certificateChangeModalClose()
            this.getCertificateData()
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            }
          })
        }
      })
    },
    getCertificateData (value = 1) {
      this.certificateTableLoading = true
      this.certificate.page = value
      this.certificateSearchForm['size'] = this.certificate.size
      this.certificateSearchForm['page'] = this.certificate.page
      getOpsCenterCertificate(this.certificateSearchForm).then(res => {
        console.log(res)
        let result = res.data
        this.certificate.data = result.results
        this.certificate.count = result.count
        this.certificateTableLoading = false
      }).catch(res => {
        this.certificateTableLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取凭证列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    certificateSearchReset () {
      this.certificateSearchForm.name = ''
      this.certificateSearchForm.protocol = ''
      this.certificateSearchForm.username = ''
      this.certificateSearchForm.port = ''
    },
    certificateChangeModalClose () {
      this.certificateModal = false
      this.certificateFormReset()
    },
    certificateFormReset () {
      this.certificateForm.id = 0
      this.certificateForm.name = ''
      this.certificateForm.protocol = ''
      this.certificateForm.username = ''
      this.certificateForm.port = ''
      this.certificateForm.key = ''
      this.certificateForm.remark = ''
      this.certificateForm.users = []
      this.certificateForm.hosts = []
      this.certificateForm.groups = []
      this.certificateForm.asset_groups = []
    },
    getAllProtocol () {
      getOpsCenterAllProtocol().then(res => {
        this.allProtocolData = res.data
      })
    },
    certificateModifyOpen (row) {
      this.certificateForm.id = row.id
      this.certificateForm.name = row.name
      if (row.protocol) {
        this.certificateForm.protocol = row.protocol.id
      }
      this.certificateForm.username = row.username
      this.certificateForm.port = row.port
      this.certificateForm.key = row.key
      this.certificateForm.remark = row.remark
      this.certificateForm.is_admin = row.is_admin
      this.certificateForm.users = row.users.map(item => item.id)
      this.certificateForm.hosts = row.server_certificate.map(item => item.id)
      this.certificateForm.groups = row.groups.map(item => item.id)
      this.certificateForm.asset_groups = row.asset_groups.map(item => item.id)
      this.certificateModalTitle = '编辑凭证：' + row.name
      this.certificateModal = true
      // 重新设置密钥密码可见 0 -密码 1-密钥
      if (row.protocol.type === 0) {
        this.keyVisible = false
        this.pwdVisible = true
      } else {
        this.keyVisible = true
        this.pwdVisible = false
      }
    },
    certificateDelete (row) {
      deleteOpsCenterCertificate(row.id).then(res => {
        if (res.status === 204) {
          this.$Notice.success({title: '操作成功！'})
          this.getCertificateData()
        } else {
          this.$Notice.error({title: res.data.data})
        }
      }).catch(res => {
        this.$Notice.error({
          title: '操作失败！ 错误状态码:' + res.request.status,
          desc: res.request.responseText
        })
      })
    },

    // 协议
    protocolModalCancel () {
      this.protocolFormReset()
    },
    protocolSubmit () {
      this.$refs['protocolForm'].validate((valid) => {
        if (valid) {
          changeOpsCenterProtocol(this.protocolForm, this.protocolForm.id).then(res => {
            this.$Notice.success({
              title: '操作成功'
            })
            this.protocolChangeModalClose()
            this.getProtocolData()
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            }
          })
        }
      })
    },
    getProtocolData (value = 1) {
      this.protocolTableLoading = true
      this.protocol.page = value
      let params = {
        'size': this.protocol.size,
        'page': this.protocol.page
      }
      getOpsCenterProtocol(params).then(res => {
        let result = res.data
        this.protocol.data = result.results
        this.protocol.count = result.count
        this.protocolTableLoading = false
      }).catch(res => {
        this.protocolTableLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取协议列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    protocolChangeModalClose () {
      this.protocolModal = false
      this.protocolFormReset()
    },
    protocolFormReset () {
      this.protocolForm.id = 0
      this.protocolForm.name = ''
      this.protocolForm.type = 0
    },
    protocolModifyOpen (row) {
      this.protocolForm.id = row.id
      this.protocolForm.name = row.name
      this.protocolForm.type = row.type
      this.protocolModalTitle = '编辑协议：' + row.name
      this.protocolModal = true
    },
    protocolDelete (row) {
      deleteOpsCenterProtocol(row.id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getProtocolData()
      }).catch(res => {
        this.$Notice.error({
          title: '操作失败！ 错误状态码:' + res.request.status,
          desc: res.request.responseText
        })
      })
    },

    // 修改记录
    revisionLog (id, ContentTypeId) {
      let params = {
        object_id: id,
        content_type: ContentTypeId
      }
      getRevisionLogs(params).then(res => {
        this.RevisionLogs = res.data
      })
    },

    // 解锁
    unlockModalCancel () {
      this.unlock.certificate_id = ''
      this.unlock.currentUserPassword = ''
      this.displayPassword = ''
    },
    unlockSubmit () {
      UnlockCertificateKey(this.unlock).then(res => {
        if (res.data.code === 200) {
          this.displayPassword = res.data.data
        } else {
          this.$Notice.error({
            title: '解密失败！',
            desc: res.data.msg
          })
        }
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    // 解锁记录
    unlockLog (id) {
      let params = {
        certificate: id
      }
      getUnlockLogs(params).then(res => {
        this.UnlockLogs = res.data
      })
    },
    // 凭证选择用户
    userChange (newTargetKeys) {
      this.certificateForm.users = newTargetKeys
    },
    // 凭证选择主机
    hostChange (newTargetKeys) {
      this.certificateForm.hosts = newTargetKeys
    },
    getNoSelectUser () {
      let that = this
      that.no_select_users = []
      GetALLUsers().then(res => {
        if (res.status === 200) {
          let result = res.data
          for (let i in result) {
            that.no_select_users.push({
              key: result[i].id,
              label: result[i].username
            })
          }
        }
      })
    },
    getNoSelectHost () {
      let that = this
      that.no_select_hosts = []
      getOpsCenterAllServer().then(res => {
        if (res.status === 200) {
          let result = res.data
          for (let i in result) {
            // console.log(i)
            that.no_select_hosts.push({
              key: result[i].id,
              label: result[i].hostname
            })
          }
        }
      })
    }
  }
}
</script>

<style>
  .ivu-poptip-body {
    text-align: left !important;
  }
</style>
